var map = {
	"./formats_preview/inread_banner.jpg": "0ecf",
	"./formats_preview/scroller.jpg": "a5fd",
	"./formats_preview/xiaomi_icon.jpg": "e9da",
	"./formats_preview/xiaomi_newsfeed_image.jpg": "a3d5",
	"./formats_preview/xiaomi_newsfeed_video.jpg": "b5ea",
	"./icons/arrow_down.svg": "4b1a",
	"./icons/arrow_up.svg": "1ad6",
	"./icons/back.svg": "7338",
	"./icons/bottom.svg": "5e8f",
	"./icons/close.svg": "8b1b",
	"./icons/desktop.svg": "83b8",
	"./icons/download.svg": "f28e",
	"./icons/game.svg": "dfde",
	"./icons/image.svg": "931c",
	"./icons/link.svg": "40a1",
	"./icons/menu.svg": "d17f",
	"./icons/mobile.svg": "0df4",
	"./icons/pause.svg": "644b",
	"./icons/play.svg": "dab1",
	"./icons/sad.svg": "9811",
	"./icons/smart_tv.svg": "4d15",
	"./icons/video.svg": "512b",
	"./laptop.png": "d897",
	"./logo.svg": "9b19",
	"./phone.png": "3547",
	"./phone_samsung.png": "715a",
	"./phone_white.jpg": "0b0f",
	"./qrcode.gif": "36bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";